import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history/Contemporary_Period_-_Rise_of_China.png';

function HistoryPageRiseOfChina() {
  return (
    <TopicPage
      topicKey="Rise of China"
      title="History: Rise of China"
      backgroundImage={bg}
      startRoute="/History-Rise-of-China-Go"
      scrollLabels={[
        "Economic Reforms and Growth",
        "Global Influence and Trade",
        "Modern Political System"
      ]}
      backRoute="/history-contemporary"
      backLabel="← Return to topics"
      backButtonClassName="journey-button special"
      backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}

export default HistoryPageRiseOfChina;
